import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import type { ManualReferralImportBatch } from '../types/bulk-referral.type';

export const importHistoryKeys = {
  all: ['admin', 'manual-referrals', 'import-history'] as const,
};

export const useImportHistory = (): UseQueryResult<ManualReferralImportBatch[], Error> => {
  return useQuery({
    queryKey: importHistoryKeys.all,
    queryFn: adminManualReferralsApi.fetchImportHistory,
  });
};
